__webpack_require__.p = "/modules/frenkitsearch/views/js/search/";